
<template >
    <div >
<h3>{{imagenesBase}}</h3> 

    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Imagnes Base</v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab">
       
       <v-tab href="#one">
          <v-icon left>mdi-account</v-icon>
          Registro
        </v-tab>
        
        <v-tab href="#two" >
          <v-icon left>mdi-dns</v-icon>
          Listado
        </v-tab>
    </v-tabs>
         <v-tabs-items :value="tab"> 
          <!-- <div :value="tab"> -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
   
    <v-text-field
           v-model="imagenesBase.descripcion"
           label="Descripcion"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   

     <v-text-field
           v-model="imagenesBase.tipo"
           label="Tipo"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
<v-avatar
:size="zoom*2"
>
    
 <a data-fancybox data-caption="Single image" :href="server_url+'api/imagenes_base/get_imagenes_base/'+ imagenesBase.linkPhoto">
        <img :src="server_url +'api/imagenes_base/get_imagenes_base/'+imagenesBase.linkPhoto" style="height:20vh" />
      </a>

    </v-avatar>

    
          <v-file-input
            v-if="!fileData.url"
            v-model="archivo"
            show-size
            chips
            label="Adjuntar Imagen"
            prepend-icon="mdi-file"
            @change="uploadFile"
            ref="file_perfil"
            data-cy="file-input"
          ></v-file-input>
          <div v-if="fileData.url">
            <p>Archivo Agregado</p>
            <span>
              <a :href="server_url +'api/imagenes_base/get_imagenes_base/'+ fileData.url">
                {{ fileData.name }}
                <v-icon color="blue">mdi-download</v-icon>
              </a>
              <button @click="removeFile()">
                <v-icon color="red">mdi-delete</v-icon>
              </button>
            </span>
          </div>


   
    <v-text-field
           v-model="imagenesBase.linkPhoto"
           label="LinkPhoto"
        
         ></v-text-field>
   
    <v-text-field
           v-model="imagenesBase.icon"
           label="Icon"
           
         ></v-text-field>
   
  
   
   
   

 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>


      
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrar"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="reset();"
      >
        Cancelar
      </v-btn>
  
    </v-form> 
            </v-card-text>


           <v-card-text>

            <v-alert
      border="top"
      colored-border
      type="info"
      elevation="2"
      
    >
      El presente registro es responsable de almacenar información sobre el Imagenes Base.<br>
      
    </v-alert>

          </v-card-text>




          </v-card>
        </v-tab-item>

   <!--  fin item 1-->
<v-tab-item value="two">
          <v-card flat>
            <v-card-text>

<v-text-field
            v-model="buscador" 
            placeholder="Ejemplo: Juan Perez"
            outlined
           
          >
          <template v-slot:label>
          <v-icon style="vertical-align: middle">
            mdi-magnify
          </v-icon>
          Busqueda por nombre de Imagenes Base
        </template>
          
          
          </v-text-field>



             
 <v-simple-table fixed-header>
    <template v-slot:default>


      <thead class="thead-dark">
        <tr>    
			
		<th scope="col">Id</th>
		<th scope="col">Descripcion</th>
		<th scope="col">Tipo</th>
		<th scope="col">LinkPhoto</th>
		<th scope="col">Icon</th>

		        <th scope="col">Editar</th>
		          <th scope="col">Eliminar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="imagenesBase in imagenesBasesBuscados" :key="imagenesBase.codigo">       
<td>{{imagenesBase.id}}</td>


<td>{{imagenesBase.descripcion}}</td>


<td>{{imagenesBase.tipo}}</td>


<td>
   <v-avatar :size="50">
       <img
        :src="server_url+'api/imagenes_base/get_imagenes_base/'+ imagenesBase.linkPhoto"
        alt="Img"> 
    </v-avatar>
   </td> 

<td><v-icon size="64">{{imagenesBase.icon}}</v-icon></td>

<td>
              <ImagenesBaseDialog :imagenesBaseData="imagenesBase"   @imagenesBaseEdit="recibirImagenesBase"></ImagenesBaseDialog>
              
            </td>
            <td>
              <button @click="eliminarImagenesBase(imagenesBase)" class="btn"><v-icon left>mdi-delete-forever</v-icon></button>
            </td>
     
 </tr>
      </tbody>
    </template>
  </v-simple-table>

            </v-card-text>
          </v-card>
        </v-tab-item>

        <!--  fin item 2-->
     

      </v-tabs-items> 

          <!-- </div> -->
    </v-card>


  </div>
</template>


<script>



import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';


import { http } from "@/services/config";


import imagenesBaseService from "@/services/imagenesBaseService.js";

import axios from 'axios'

import ImagenesBaseDialog from '../base/ImagenesBaseDialog';



export default {
     name: 'ImagenesBase',
    
  components: {
   ImagenesBaseDialog
  },
  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get () {
        return this.$route.query.tab
      }
    }
  },
    data: vm => ({
       zoom: 50,
        archivo: null,
      fileData: {
        url: "",
        name:""
      },
       server_url: "",
    valid: true,
    tab:"",
    buscador:'',
showPass: false,
  imagenesBases: [],
        imagenesBase:{
id:'',
descripcion:'',
tipo:'',
linkPhoto:'',
icon:''
        },

        rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
        
        
        
        
        
        
    
  }),
  created(){

       }
  ,mounted(){
      this.listarImagenesBases();
    
      this.tab="two";

       Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });

     this.server_url = http.defaults.baseURL;

   
    },

  methods: {

     uploadFile: function () {
      this.imagenesBase.linkPhoto=this.fileData.url;
      if (this.archivo) this.submitFile();
      else this.removeFile();
    },
    submitFile() {

      this.fileData.name=this.archivo.name;
      console.log(this.archivo);
      const formData = new FormData();
      formData.append("file_imagenesBase", this.archivo);
      formData.append("imagenesBase", JSON.stringify(this.imagenesBase));
    //  formData.append('data', this.imagenesBase);
      //formData.append("identificador", this.principal.identificador);
      formData.append("imagenesBase_id", this.imagenesBase.id);
      const headers = { "Content-Type": "multipart/form-data" ,
      'Authorization':'Bearer '+ localStorage.getItem("token")};
      console.log(formData);
      http
        .post(this.server_url + "api/imagenes_base/save_imagenes_base/"+this.imagenesBase.id, formData, { headers })
                                  
        .then((res) => {
          
         this.imagenesBase.linkPhoto=res.data.imagenesBase.linkPhoto;
         this.fileData.url=res.data.imagenesBase.linkPhoto;

         console.log(this.imagenesBase.linkPhoto);
        });
    },
    removeFile() {
        this.fileData = { url: "" };
      
        this.archivo=null;

        this.imagenesBase.linkPhoto='';
  
    },
    
    listarImagenesBases() {
      imagenesBaseService
        .listarImagenesBases()
        .then((resposta) => {
      //    console.log(resposta.data);
          this.imagenesBases = resposta.data;
        })
  
  },
    registrar(){
    if (this.$refs.form.validate()) {
   
          if(this.imagenesBase.codigo===""||this.imagenesBase.codigo===null){
      //Eliminar para que funcione el auto incrementable
        delete this.imagenesBase.codigo;
          }

        console.log(this.imagenesBase);

          imagenesBaseService.save(this.imagenesBase,this.config).then(resposta=>{
           this.limpiar();
              alert('Guardado exitoso!!')
              this.listarImagenesBases();
               this.selectedTab="second";
          });


        
      }
    },
    eliminarImagenesBase(imagenesBase){

      console.log(imagenesBase);

        if(confirm('Desea remover al imagenesBase')){
        
        imagenesBaseService.delete(imagenesBase).then(resposta=>{
          this.listarImagenesBases();
          this.errors=[]
          this.limpiar();

        }).catch(e=>{

          this.errors =e.response.data.errors

        })

        }


        


    },
    limpiar(){

     
		this.imagenesBase={
				id:'',
				descripcion:'',
				tipo:'',
				linkPhoto:'',
				icon:''
	}

        
    },
		
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  recibirImagenesBase:function(imagenesBase){

      console.log('En elemento padre ImagenesBase despues de editar');
        console.log(imagenesBase);
 
    },
  },

    watch: {
      date (val) {
        
		
       
      },
    },
  computed:{
    


    	
    imagenesBasesBuscados() {
          return this.imagenesBases.filter(imagenesBase => {
            return imagenesBase.descripcion.toLowerCase().includes(this.buscador.toLowerCase());
          });
    
      }
    
  
  },
};
</script>




